import type { DateRange } from '../types';

export const CALENDAR_KEYS = {
  all: ['calendar'] as const,
  byOrg: (orgId: string) => ['calendar', orgId] as const,
  tasks: (orgId: string, range: DateRange) => ['calendar', orgId, 'tasks', range] as const,
  timeEntries: (orgId: string, range: DateRange) =>
    ['calendar', orgId, 'time-entries', range] as const,
};

/**
 * External calendar connections — user-scoped, NOT tenant-scoped.
 * Deliberately without orgId: connections live at the user level (skipTenantHeader).
 */
export const CALENDAR_CONNECTIONS_KEYS = {
  all: ['calendar-connections'] as const,
};

/**
 * External events synced from Google/Microsoft — tenant-scoped.
 * X-Tenant-Id determines which Tenant-scoped events are included, so orgId
 * is part of every key (same pattern as CALENDAR_KEYS).
 */
export const EXTERNAL_CALENDAR_EVENTS_KEYS = {
  root: (orgId: string) => ['calendar', orgId, 'external-events'] as const,
  range: (orgId: string, range: DateRange) =>
    ['calendar', orgId, 'external-events', range] as const,
};
